import React from 'react';
import Footer from '../components/Commons/Footer';
import Header from '../components/Commons/Header';
import RecoverPasswordBlock from '../components/LoginFlow/RecoverPassword';
import { Desktop } from '../utils/responsiveRules';

export default function RecoverPassword() {
  return (
    <>
      <Header hasLogin={false} />
      <RecoverPasswordBlock />
      <Desktop>
        <Footer />
      </Desktop>
    </>
  )
}